import { PublicRequester } from '@/features/api/client.service.js'
import { makeApiRequest } from '@/features/api/services/utils/makeApiRequest.js'

export const publicApiEndpoints = {
  tenantDownloadBackgroundImage: '/Public/Tenant/DownloadBackgroundImage',
  tenantDownloadLogo: '/Public/Tenant/DownloadLogo',
  tenantDetails: '/Public/Tenant/Details',
}

export const PublicApi = {
  tenantLogoBackgroundImage: async id =>
    makeApiRequest(
      () =>
        PublicRequester.put({
          url: publicApiEndpoints.tenantDownloadBackgroundImage,
          queryParams: { Id: id },
          responseType: 'blob',
        }),
      response => response,
    )(),

  tenantLogoDownloadImage: async id =>
    makeApiRequest(
      () =>
        PublicRequester.put({
          url: publicApiEndpoints.tenantDownloadLogo,
          queryParams: { Id: id },
          responseType: 'blob',
        }),
      response => response,
    )(),

  tenantDetails: async id =>
    makeApiRequest(() =>
      PublicRequester.put({
        url: publicApiEndpoints.tenantDetails,
        queryParams: { Id: id },
      }),
    )(),
}
